import { render, staticRenderFns } from "./TodoTaskList.vue?vue&type=template&id=12386f57"
import script from "./TodoTaskList.vue?vue&type=script&lang=js"
export * from "./TodoTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12386f57')) {
      api.createRecord('12386f57', component.options)
    } else {
      api.reload('12386f57', component.options)
    }
    module.hot.accept("./TodoTaskList.vue?vue&type=template&id=12386f57", function () {
      api.rerender('12386f57', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/workflow/TodoTaskList.vue"
export default component.exports